import { type PropsWithChildren, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { defaultTheme } from '../constants';
import { type Theme } from '../styled';

export function LayoutThemeProvider({ children }: PropsWithChildren) {
  const {
    columnCornerRadius: settingsColumnCornerRadius,

    headFeaturesFont: settingsHeadFeaturesFont,
    headTextColor: settingsHeadTextColor,
    headTitleFont: settingsHeadTitleFont,

    button: settingsButtonSettings,
    buttonAlignment: settingsButtonAlignment,

    pictureAspectRatio: settingsPictureAspectRatio,

    titleAlignment: settingsTitleAlignment,
    titleCaptionColor: settingsTitleCaptionColor,
    titleCaptionFont: settingsTitleCaptionFont,
    titleFont: settingsTitleFont,

    featuresFont: settingsFeaturesFont,
    featuresStyle: settingsFeaturesStyle,

    discountFont: settingsDiscountFont,
    discountTextColor: settingsDiscountTextColor,
    oldPriceColor: settingsOldPriceColor,
    oldPriceFont: settingsOldPriceFont,
    priceAlign: settingsPriceAlign,
    priceCaptionColor: settingsPriceCaptionColor,
    priceCaptionFont: settingsPriceCaptionFont,
    priceColor: settingsPriceColor,
    priceFont: settingsPriceFont
  } = useSettings();

  const theme: Theme = useMemo(
    () => ({
      ...defaultTheme,
      headColumn: {
        color: settingsHeadTextColor,
        featuresFont: settingsHeadFeaturesFont,
        titleFont: settingsHeadTitleFont
      },
      column: {
        cornerRadius: settingsColumnCornerRadius
      },
      button: {
        ...settingsButtonSettings,
        alignment: settingsButtonAlignment
      },
      picture: {
        aspectRatio: settingsPictureAspectRatio
      },
      features: {
        font: settingsFeaturesFont,
        type: settingsFeaturesStyle
      },
      price: {
        font: settingsPriceFont,
        color: settingsPriceColor,
        captionColor: settingsPriceCaptionColor,
        captionFont: settingsPriceCaptionFont,
        alignment: settingsPriceAlign,
        oldPriceColor: settingsOldPriceColor,
        oldPriceFont: settingsOldPriceFont,
        discountTextColor: settingsDiscountTextColor,
        discountFont: settingsDiscountFont
      },
      title: {
        alignment: settingsTitleAlignment,
        font: settingsTitleFont,
        captionFont: settingsTitleCaptionFont,
        captionColor: settingsTitleCaptionColor
      }
    }),
    [
      settingsHeadFeaturesFont,
      settingsHeadTextColor,
      settingsHeadTitleFont,
      settingsColumnCornerRadius,
      settingsButtonSettings,
      settingsButtonAlignment,
      settingsPictureAspectRatio,
      settingsFeaturesFont,
      settingsFeaturesStyle,
      settingsPriceFont,
      settingsPriceColor,
      settingsPriceAlign,
      settingsPriceCaptionColor,
      settingsTitleAlignment,
      settingsTitleFont,
      settingsTitleCaptionFont,
      settingsTitleCaptionColor,
      settingsPriceCaptionFont,
      settingsOldPriceColor,
      settingsOldPriceFont,
      settingsDiscountTextColor,
      settingsDiscountFont
    ]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
